import { render, staticRenderFns } from "./Four.vue?vue&type=template&id=2eadf528&scoped=true"
var script = {}
import style0 from "./Four.vue?vue&type=style&index=0&id=2eadf528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eadf528",
  null
  
)

export default component.exports